export default class SecondaryMenu {
  constructor() {
    this.$secondaryMenu = $('#secondary-menu-ul');
    this.$this = $('.header__secondary-menu');
    this.$menuItems = this.$secondaryMenu.find('.secondary-menu-item-0');
    this.$header = $('#header');
    this.$html = $('html');
    this.$hamburgerMenu = $('.js-hamburger');
    this.$headerTitle = $('.header__secondary-title');
    this.$toggleButton = $('.header__secondary-toggle');
    this.$menuItemsContainer = $('.header__secondary-menu-items');
    this.isOpenChild = 'is-open-child';
    this.isOpenMenu = 'is-open-menu';
    this.isOpen = 'is-open';
    this.ariaExpanded = 'aria-expanded';
    this.$headerMobile = $('.header-mobile');
    this.$backButton = $('.secondary-sub-menu-back-btn');
    this.$closeButton = $('.header__secondary-close-menu');
    this.elmMenuItemLink = '> .secondary-menu-item-wrapper > .secondary-menu-item-link';
  }

  init() {
    if (this.$secondaryMenu.length) {
      this.handleToggleButton();
      this.handleMobileMenuToggle();
      this.handleSubMenuToggle();
      this.setHeightNavMainHeader();
      if (($(window).width() < 1200) && (this.$headerTitle.length)) {
        this.$headerTitle.on('click', (e) => {
          e.preventDefault();
          this.$toggleButton.trigger('click');
        });
      }
    }
  }

  setHeightNavMainHeader() {
    this.$html.css({
      '--height-nav-main-header': ``,
      '--height-nav-secondary-header': ``,
    });
    setTimeout(() => {
      this.$html.css({
        '--height-nav-main-header': `${this.$headerMobile.outerHeight()}px`,
        '--height-nav-secondary-header': `${this.$this.find('>.container').outerHeight()}px`,
      });
    }, 50);
  }

  handleToggleButton() {
    this.$toggleButton.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (this.$toggleButton.hasClass(this.isOpen)) {
        this.$toggleButton.removeClass(this.isOpen);
        this.$this.removeClass(this.isOpenMenu);
      } else {
        this.$toggleButton.addClass(this.isOpen);
        this.$this.addClass(this.isOpenMenu);
      }
    });
  }

  handleMobileMenuToggle() {
    // When main hamburger menu is toggled, reset secondary menu
    this.$hamburgerMenu.on('click', () => {
      const isOpen = this.$header.hasClass(this.isOpenMenu);

      if (!isOpen) {
        // Menu is closing - reset secondary menu
        this.closeAllSubmenus();
        this.$toggleButton.removeClass(this.isOpen);
      }
    });
    $('.secondary-sub-menu-back-btn').on('click', (e) => {
      const $parent = $(e.currentTarget).closest('li');
      if ($parent.length) {
        $parent.removeClass(this.isOpenChild);
        $parent.find(this.elmMenuItemLink).attr(this.ariaExpanded, false);
      }
    });
    this.$closeButton.on('click', () => {
      this.$toggleButton.removeClass(this.isOpen);
      this.$this.removeClass(this.isOpenMenu);
    });
  }

  handleSubMenuToggle() {
    // Desktop: hover behavior
    if ($(window).width() >= 1200) {
      this.$menuItems.on('mouseenter', (e) => {
        const $item = $(e.currentTarget);
        if ($item.hasClass('has-sub')) {
          $item.addClass(this.isOpenChild);
          $item.find(this.elmMenuItemLink).attr(this.ariaExpanded, true);
        }
      });

      this.$menuItems.on('mouseleave', (e) => {
        const $item = $(e.currentTarget);
        if ($item.hasClass('has-sub')) {
          $item.removeClass(this.isOpenChild);
          $item.find(this.elmMenuItemLink).attr(this.ariaExpanded, false);
        }
      });
    }

    // Mobile: click behavior
    this.$menuItems.on('click', '.secondary-menu-item-wrapper', (e) => {
      if ($(window).width() < 1200) {
        const $wrapper = $(e.currentTarget);
        const $item = $wrapper.parent();

        if ($item.hasClass('has-sub')) {
          e.preventDefault();
          e.stopPropagation();

          // Close other submenus
          this.$menuItems.not($item).removeClass(this.isOpenChild);
          this.$menuItems.not($item).find('.secondary-menu-item-link').attr(this.ariaExpanded, false);

          // Toggle current submenu
          if ($item.hasClass(this.isOpenChild)) {
            $item.removeClass(this.isOpenChild);
            $item.find(this.elmMenuItemLink).attr(this.ariaExpanded, false);
          } else {
            $item.addClass(this.isOpenChild);
            $item.find(this.elmMenuItemLink).attr(this.ariaExpanded, true);
          }
        }
      }
    });

    // Handle window resize
    $(window).on('resize', () => {
      this.setHeightNavMainHeader();
      if ($(window).width() >= 1200) {
        this.closeAllSubmenus();
      }
    });
  }

  closeAllSubmenus() {
    this.$menuItems.removeClass(this.isOpenChild);
    this.$menuItems.find('.secondary-menu-item-link').attr(this.ariaExpanded, false);
  }
}

new SecondaryMenu().init();
